(function () {
    'use strict';

    angular
        .module('homeControllers', ['homeDashboardControllers',
                                    'homeMyTasksControllers',
                                    'riskModule',
                                    'services.authenticatedUser',
                                    'actionPlanModule',
                                    'governanceProcessModule',
                                    'services.permission']);
})();
